import Phaser from 'phaser';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  create(): void {
    const { width, height } = this.scale;

    // Title
    this.add
      .text(width / 2, height / 2 - 60, 'MAFIA CITY', {
        fontSize: '48px',
        fontFamily: 'monospace',
        color: '#ff6b35',
      })
      .setOrigin(0.5);

    // Subtitle
    this.add
      .text(width / 2, height / 2, 'Loading...', {
        fontSize: '18px',
        fontFamily: 'monospace',
        color: '#cccccc',
      })
      .setOrigin(0.5);

    // Transition after brief delay (use setTimeout to avoid Phaser timer pause in background tabs)
    setTimeout(() => {
      this.scene.start('LoginScene');
    }, 1000);
  }
}
